var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66602 1.5H15.666C16.491 1.5 17.166 2.175 17.166 3V12C17.166 12.825 16.491 13.5 15.666 13.5H5.16602L2.16602 16.5L2.17352 3C2.17352 2.175 2.84102 1.5 3.66602 1.5ZM5.91602 8.25H7.41602V6.75H5.91602V8.25ZM10.416 8.25H8.91601V6.75H10.416V8.25ZM11.916 8.25H13.416V6.75H11.916V8.25Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.368ef0427ac24efc21b66477f533a6d5.svg";
export { ForwardRef as ReactComponent };